
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7SGXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $5bcee7c27149d913$var$_jquery = $5bcee7c27149d913$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $5bcee7c27149d913$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $5bcee7c27149d913$var$screencheck = function screencheck(mediasize) {
    var screensize = window.matchMedia("(max-width:" + mediasize + "px)");
    return !!screensize.matches;
};
var $5bcee7c27149d913$var$scrollToAnchor = function scrollToAnchor(anchor) {
    if ((0, $5bcee7c27149d913$var$_jquery["default"])(anchor).length > 0) {
        (0, $5bcee7c27149d913$var$_jquery["default"])(".join-steps li").removeClass("active");
        var offsetTop = (0, $5bcee7c27149d913$var$_jquery["default"])(anchor).offset().top;
        (0, $5bcee7c27149d913$var$_jquery["default"])('.join-steps a[href="' + anchor + '"]').parent().addClass("active");
        var aktScrollPos = (0, $5bcee7c27149d913$var$_jquery["default"])(document).scrollTop();
        // Version 2: fixed Header gar nicht erst einblenden
        if (aktScrollPos > offsetTop) fixed = false;
        (0, $5bcee7c27149d913$var$_jquery["default"])(".join-steps li").each(function() {
            var hash = (0, $5bcee7c27149d913$var$_jquery["default"])(this).find("a").attr("href");
        });
        (0, $5bcee7c27149d913$var$_jquery["default"])("html, body").stop().animate({
            scrollTop: offsetTop - 40
        }, 300, function() {
            // Version 2: fixed Header gar nicht erst einblenden: Wert zurücksetzen
            window.setTimeout(function() {
                fixed = true;
            }, 300);
        });
    }
};
var $5bcee7c27149d913$var$init = module.exports.init = function init() {
    var attempts = 0;
    (0, $5bcee7c27149d913$var$_jquery["default"])("body").addClass("youth");
    // ==============================================================
    /*
   * rwdImageMaps jQuery plugin v1.6
   *
   * Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
   *
   * Copyright (c) 2016 Matt Stow
   * https://github.com/stowball/jQuery-rwdImageMaps
   * http://mattstow.com
   * Licensed under the MIT license
   */ $5bcee7c27149d913$var$_jquery["default"].fn.rwdImageMaps = function() {
        var $img = this;
        var rwdImageMap = function rwdImageMap() {
            $img.each(function() {
                if (typeof (0, $5bcee7c27149d913$var$_jquery["default"])(this).attr("usemap") == "undefined") return;
                var that = this;
                var $that = (0, $5bcee7c27149d913$var$_jquery["default"])(that);
                // Since WebKit doesn't know the height until after the image has loaded, perform everything in an onload copy
                (0, $5bcee7c27149d913$var$_jquery["default"])("<img />").on("load", function() {
                    var attrW = "width", attrH = "height", w = $that.attr(attrW), h = $that.attr(attrH);
                    if (!w || !h) {
                        var temp = new Image();
                        temp.src = $that.attr("src");
                        if (!w) w = temp.width;
                        if (!h) h = temp.height;
                    }
                    var wPercent = $that.width() / 100, hPercent = $that.height() / 100, map = $that.attr("usemap").replace("#", ""), c = "coords";
                    (0, $5bcee7c27149d913$var$_jquery["default"])('map[name="' + map + '"]').find("area").each(function() {
                        var $this = (0, $5bcee7c27149d913$var$_jquery["default"])(this);
                        if (!$this.data(c)) $this.data(c, $this.attr(c));
                        var coords = $this.data(c).split(",");
                        var coordsPercent = new Array(coords.length);
                        for(var i = 0; i < coordsPercent.length; ++i)if (i % 2 === 0) coordsPercent[i] = parseInt(coords[i] / w * 100 * wPercent);
                        else coordsPercent[i] = parseInt(coords[i] / h * 100 * hPercent);
                        $this.attr(c, coordsPercent.toString());
                    });
                }).attr("src", $that.attr("src"));
            });
        };
        (0, $5bcee7c27149d913$var$_jquery["default"])(window).resize(rwdImageMap).trigger("resize");
        return this;
    };
    // ==============================================================
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            (0, $5bcee7c27149d913$var$_jquery["default"])(".youth-video-intro-banner").not((0, $5bcee7c27149d913$var$_jquery["default"])(".youth-video-intro-banner.yt")).each(function() {
                var $this = (0, $5bcee7c27149d913$var$_jquery["default"])(this);
                var video = $this.find(".youth-header-video > .video");
                var modalVideo = $this.find(".youth-header-video .modal .video");
                var modalIFrame = $this.find(".youth-header-video .modal iframe video");
                var modal = $this.find(".modal");
                var playButton = $this.find(".start");
                if ((0, $5bcee7c27149d913$var$_jquery["default"])(".youth-header-video .modal video").length) {
                    playButton.on("click", function() {
                        if ((0, $5bcee7c27149d913$var$_jquery["default"])(document).width() <= 767) {
                            playButton.show();
                            modal.modal();
                            if (modalVideo.get(0).paused === true) {
                                modalVideo.get(0).currentTime = 0;
                                modalVideo.get(0).play();
                                modalVideo.prop("controls", true);
                            }
                        } else if (video.get(0).paused === true) {
                            video.get(0).currentTime = 0;
                            video.get(0).play();
                            playButton.hide();
                            video.prop("controls", true);
                        }
                    });
                    modal.on("hide.bs.modal", function() {
                        modalVideo.get(0).pause();
                        modalIFrame.removeClass("paused-mode");
                        modalIFrame.addClass("playing-mode");
                    });
                }
                if ((0, $5bcee7c27149d913$var$_jquery["default"])(".youth-header-video .modal iframe").length) {
                    (0, $5bcee7c27149d913$var$_jquery["default"])(".youth-header-video").addClass("iframe");
                    playButton.on("click", function() {
                        if ((0, $5bcee7c27149d913$var$_jquery["default"])(document).width() <= 767) {
                            playButton.show();
                            modal.modal();
                        } else if (modalIFrame.get(0).paused === true) {
                            modalIFrame.get(0).currentTime = 0;
                            modalIFrame.get(0).play();
                            playButton.hide();
                            modalIFrame.prop("controls", true);
                        }
                    });
                    modal.on("hide.bs.modal", function() {});
                }
            });
            // Video header YT
            (0, $5bcee7c27149d913$var$_jquery["default"])(".youth-video-intro-banner.yt").each(function() {
                var $this = (0, $5bcee7c27149d913$var$_jquery["default"])(this);
                var playButton = $this.find(".start");
                playButton.on("click", function() {
                    var modal = $this.find(".modal");
                    var video = $this.find("#youtubevideo");
                    var modalVideo = $this.find("#youtubevideomodal");
                    if (modalVideo.find("iframe").length === 0) video.find("iframe").appendTo(modalVideo);
                    modal.modal();
                    modal.on("hide.bs.modal", function() {
                        if (video.find("iframe").length === 0) modalVideo.find("iframe").appendTo(video);
                    });
                });
                window.addEventListener("ucEvent", function(e) {
                    if (e.detail && e.detail.event == "consent_status") {
                        if (e.detail["YouTube Video"] === true) {
                            var modal = $this.find(".modal");
                            var video = $this.find("#youtubevideo");
                            var modalVideo = $this.find("#youtubevideomodal");
                            setTimeout(function() {
                                if (modal.hasClass("in")) {
                                    if (modalVideo.find("iframe").length === 0) {
                                        console.log(video.find("iframe"));
                                        video.find("iframe").appendTo(modalVideo);
                                    }
                                } else if (video.find("iframe").length === 0) modalVideo.find("iframe").appendTo(video);
                            }, 500);
                        }
                    }
                });
            });
            if ((0, $5bcee7c27149d913$var$_jquery["default"])(".fixed-sidebar a.btn, .social-block a.btn").length > 0) // Scroll spy Topmenu -------------------------------------------------------------
            (0, $5bcee7c27149d913$var$_jquery["default"])(".fixed-sidebar a.btn, .social-block a.btn").on("click", function(event) {
                event.preventDefault();
                var href = (0, $5bcee7c27149d913$var$_jquery["default"])(this).attr("href");
                $5bcee7c27149d913$var$scrollToAnchor(href);
            });
            // Panels
            (0, $5bcee7c27149d913$var$_jquery["default"])(".read-more-panel").each(function(e) {
                var $this = (0, $5bcee7c27149d913$var$_jquery["default"])(this);
                (0, $5bcee7c27149d913$var$_jquery["default"])(this).find(".panel-open").on("click", function() {
                    $this.find(".read-more-panel-body").slideDown();
                    $this.find(".read-more-panel-footer.open").slideDown();
                    $this.find(".read-more-panel-footer.closed").slideUp();
                });
                (0, $5bcee7c27149d913$var$_jquery["default"])(this).find(".panel-close").on("click", function() {
                    $this.find(".read-more-panel-body").slideUp();
                    $this.find(".read-more-panel-footer.open").slideUp();
                    $this.find(".read-more-panel-footer.closed").slideDown();
                });
            });
            // =============================================================================
            // sidebar toggle (mobile Inpage-Navigation
            // =============================================================================
            (0, $5bcee7c27149d913$var$_jquery["default"])("#sidebar-toggle").on("click", function() {
                if ($5bcee7c27149d913$var$screencheck(1023)) (0, $5bcee7c27149d913$var$_jquery["default"])(this).next(".sidebar-section").slideToggle();
            });
            // =============================================================================
            // window RESIZE
            // =============================================================================
            (0, $5bcee7c27149d913$var$_jquery["default"])(window).resize(function(e) {
                if ((0, $5bcee7c27149d913$var$_jquery["default"])(".youth #logofooter").length > 0) {
                    var $src = (0, $5bcee7c27149d913$var$_jquery["default"])("#logofooter img").attr("src");
                    var $srcV = "-quad";
                    var $newSrc = "";
                    if ((0, $5bcee7c27149d913$var$_jquery["default"])(this).width() < 1000) {
                        if ($src.indexOf($srcV) === -1) {
                            $newSrc = $src.replace("jugend", "jugend-quad");
                            (0, $5bcee7c27149d913$var$_jquery["default"])("#logofooter img").attr("src", $newSrc);
                        }
                    } else if ($src.indexOf($srcV) !== -1) {
                        $newSrc = $src.replace("jugend-quad", "jugend");
                        (0, $5bcee7c27149d913$var$_jquery["default"])("#logofooter img").attr("src", $newSrc);
                    }
                }
                if ((0, $5bcee7c27149d913$var$_jquery["default"])(".youth-video-intro-banner.yt").length > 0) (0, $5bcee7c27149d913$var$_jquery["default"])(".youth-video-intro-banner.yt").each(function() {
                    if ((0, $5bcee7c27149d913$var$_jquery["default"])(document).width() > 767) (0, $5bcee7c27149d913$var$_jquery["default"])(this).find(".modal").modal("hide");
                });
            });
            // =============================================================================
            // interactive map
            // =============================================================================
            if ((0, $5bcee7c27149d913$var$_jquery["default"])(".interactive-map").length > 0) {
                // Variables
                var coords, coordLeft, coordTop, currentTag;
                var prevTag = "";
                var initial_width = (0, $5bcee7c27149d913$var$_jquery["default"])(".youth img[usemap]").attr("width");
                var initial_height = (0, $5bcee7c27149d913$var$_jquery["default"])(".youth img[usemap]").attr("height");
                // Calculate and recalculate map areas positions
                (0, $5bcee7c27149d913$var$_jquery["default"])(".youth img[usemap]").rwdImageMaps();
                (0, $5bcee7c27149d913$var$_jquery["default"])("body.youth, html").on("resize", function() {
                    (0, $5bcee7c27149d913$var$_jquery["default"])(".youth img[usemap]").rwdImageMaps();
                });
                // City marker: on mouse over
                (0, $5bcee7c27149d913$var$_jquery["default"])(".youth area").each(function() {
                    var areaTitle = (0, $5bcee7c27149d913$var$_jquery["default"])(this).attr("data-target").toLowerCase();
                    var areaCoords = (0, $5bcee7c27149d913$var$_jquery["default"])(this).attr("coords").split(",");
                    coordLeft = areaCoords[0] / initial_width * 100;
                    coordTop = areaCoords[1] / initial_height * 94.2;
                    // console.log('.marker[data-target="'+areaTitle+'"]');
                    (0, $5bcee7c27149d913$var$_jquery["default"])('.youth .marker[data-target="' + areaTitle + '"]').css({
                        top: coordTop + "%",
                        left: coordLeft + "%",
                        display: "block"
                    });
                });
                (0, $5bcee7c27149d913$var$_jquery["default"])(".youth area").on("mouseover touchstart", function(e) {
                    e.preventDefault();
                    currentTag = (0, $5bcee7c27149d913$var$_jquery["default"])(this).attr("title").toLowerCase(); // Get city name
                    if (!(currentTag == prevTag)) {
                        prevTag = currentTag;
                        // Remove active state from all markers
                        (0, $5bcee7c27149d913$var$_jquery["default"])(".youth .markers-wrapper .marker").removeClass("active");
                        setTimeout(function() {
                            // Set active state to current city
                            (0, $5bcee7c27149d913$var$_jquery["default"])(".youth .marker[data-target=" + currentTag + "]").addClass("active");
                        }, 300);
                    }
                });
                (0, $5bcee7c27149d913$var$_jquery["default"])(".youth .marker").on("mouseover touchstart", function(e) {
                    (0, $5bcee7c27149d913$var$_jquery["default"])(".youth .markers-wrapper .marker").removeClass("active");
                    (0, $5bcee7c27149d913$var$_jquery["default"])(this).addClass("active");
                });
                // When clicked on flag
                (0, $5bcee7c27149d913$var$_jquery["default"])(".youth .marker__flag").on("click", function(e) {
                    e.preventDefault();
                    if ((0, $5bcee7c27149d913$var$_jquery["default"])(this).parent().hasClass("active")) {
                        var currentHref = (0, $5bcee7c27149d913$var$_jquery["default"])(this).attr("href");
                        (0, $5bcee7c27149d913$var$_jquery["default"])("body.youth, html").animate({
                            scrollTop: (0, $5bcee7c27149d913$var$_jquery["default"])(currentHref).offset().top - parseFloat((0, $5bcee7c27149d913$var$_jquery["default"])(currentHref).css("margin-top")) / 2
                        }, 1000);
                    }
                });
                // Remove active state from all markers
                (0, $5bcee7c27149d913$var$_jquery["default"])(".youth img[usemap]").on("click", function() {
                    prevTag = "";
                    (0, $5bcee7c27149d913$var$_jquery["default"])(".youth .markers-wrapper .marker").removeClass("active");
                });
                (0, $5bcee7c27149d913$var$_jquery["default"])("#sidebar-toggle").on("click", function() {
                    if ($5bcee7c27149d913$var$screencheck(1023)) (0, $5bcee7c27149d913$var$_jquery["default"])(this).next(".sidebar-section").slideToggle();
                });
            }
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=youth.module.8e89de8d.js.map
